<script setup>
import {useRouter} from "vue-router";

const props = defineProps({
    loading: {
        type: Boolean,
        default: false
    },
    route: {
        type: String,
        required: true
    },
    tooltipText: {
        type: String,
        default: '',
    },
    disabled: {
        type: Boolean,
        default: false,
    },
})

const router = useRouter()

const navigateToRoute = () => {
    if (props.disabled) return

    router.push(props.route);
}


</script>
<template>
    <v-btn
        type="submit"
        :loading="props.loading"
        :aria-disabled="props.disabled"
        :class="{ 'btn-disabled-tooltip': props.disabled }"
        class="btn btn-success p-0 m-0"
        v-tooltip="props.tooltipText || false"
        @click="navigateToRoute"
    >
        <i class="material-symbols-outlined me-1">add_circle_outline</i>
        {{ $t('common.labels.new') }}
    </v-btn>
</template>


<style lang="scss" scoped>
.trezo-card{
    margin-bottom: -15px;

    button,
    a {
        text-transform: none!important;
        margin: {
            right: 15px;
            bottom: 15px;
        }
        display: inline-block !important;
        padding: 8px 20px !important;
        width: auto;
        height: auto;

        &.v-btn--icon {
            width: 56px;
            height: 56px;
            padding: 0 !important;
            color: var(--whiteColor);
        }
        &.trezo {
            color: var(--primaryColor);
        }

        &.d-block {
            text-align: center !important;
            display: block !important;
            width: 100% !important;
        }
    }
    button i {
        font-size: 22px;
    }
}

.btn-disabled-tooltip {
    opacity: 0.6;
    cursor: default;
}
</style>
